import ServiceException from '@ch-types/CoralExceptionTypes/ServiceException';

export default class DependencyFailure extends ServiceException {}
